import { CLEAR_TREATMENT_LIST, RES_PER_PAGE, SAVE_TREATMENT_LIST } from "../../constants/treatment-list-const/TreatmentListConst";

const initialState = {
    treatmentList: [],
    totalCount: 0,
    curPage: 1,
}
export const TreatmentReducer = (state = initialState, action) => {
    switch (action.type) {

        case SAVE_TREATMENT_LIST:
            let newList = action.payload.items;
            if(newList[0]?.treatment_id !== state?.treatmentList[0]?.treatment_id) {
                newList = (state?.treatmentList).concat(newList);
            }

            return {
                ...state,
                treatmentList: newList,
                totalCount: action.payload.total,
                curPage: Math.ceil(newList.length / RES_PER_PAGE)
            };

        case CLEAR_TREATMENT_LIST:
            return {
                ...state,
                treatmentList: [],
                totalCount: 0,
                curPage: 1
            }
        default:
            return state
    }
}  